import React, {FunctionComponent, useState, useEffect, useRef} from "react"
// icons
import {IconContext} from "react-icons/lib"
import {IoMdMore} from "react-icons/io"
import {RequirementBlockNoteDTO} from "../api/models"
import {useCustomer} from "../../../common/contexts/CustomerContext"
import {useUpdateCustomerRequirementBlockNote, useDeleteCustomerRequirementBlockNote} from "../api/mutations"
import {UpdateBlockNoteRequest, DeleteBlockNoteRequest} from "../api/models"
import EditRow from "./EditRow"
import ModifyOptionsRow from "./ModifyOptions"
import {useParams} from "react-router-dom"

interface CommentsRowProps {
	comment: RequirementBlockNoteDTO
}

const CommentRow: FunctionComponent<CommentsRowProps> = ({comment}) => {
	const [note, setNote] = useState(comment.Note)
	const [enableEdit, setEnableEdit] = useState(false)
	const [showDropdown, setShowDropDown] = useState(false)
	const myRef = useRef<HTMLDivElement>(null)

	const {customer} = useCustomer()
	let {customerId} = useParams()
	const {mutate: updateCustomerBlockNote, isPending: updateCustomerBlockNoteIsLoading} =
		useUpdateCustomerRequirementBlockNote()
	const {mutate: deleteCustomerNote, isPending: deleteCustomerNoteIsLoading} = useDeleteCustomerRequirementBlockNote()

	useEffect(() => {
		setNote(comment.Note)
	}, [comment.Note])

	const handleNoteChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		e.preventDefault()
		setNote(e.target.value)
	}

	const onCancel = () => {
		setNote(comment.Note)
		setEnableEdit(false)
	}

	const onSave = () => {
		const submitUpdateBlock = () => {
			let cId = customerId
			if (!cId) cId = customer.Id
			const request: UpdateBlockNoteRequest = {
				CustomerId: cId,
				Note: note,
				RequirementBlockNoteId: comment.RequirementBlockNoteId
			}
			updateCustomerBlockNote(request, {
				onSettled: () => {
					console.log("done")
					setEnableEdit(false)
				},
				onError: () => {
					setEnableEdit(false)
				}
			})
		}
		submitUpdateBlock()
	}

	const handleClickInside = () => setShowDropDown(true)

	function handleClickOutside(e: MouseEvent) {
		if (!myRef.current.contains(e.target as HTMLInputElement)) {
			setShowDropDown(false)
		}
	}

	useEffect(() => {
		document.addEventListener("click", handleClickOutside)
		return () => document.removeEventListener("click", handleClickOutside)
	}, [])

	const onEdit = () => {
		setShowDropDown(false)
		setEnableEdit(true)
	}

	const onDelete = () => {
		setShowDropDown(false)
		const submitDeleteBlock = () => {
			let cId = customerId
			if (!cId) cId = customer.Id
			const request: DeleteBlockNoteRequest = {
				CustomerId: cId,
				RequirementBlockNoteId: comment.RequirementBlockNoteId
			}
			deleteCustomerNote(request, {
				onSettled: () => {
					console.log("done")
				},
				onError: () => {}
			})
		}
		submitDeleteBlock()
	}

	return (
		<div className='actions-row'>
			{!enableEdit && <div className='actions-text'>{comment.Note}</div>}
			<EditRow
				description={note}
				enableEdit={enableEdit}
				onSave={onSave}
				onCancel={onCancel}
				handleTextChange={handleNoteChange}
				isLoading={updateCustomerBlockNoteIsLoading}
			/>
			<div className='actions-select-container' onClick={handleClickInside} ref={myRef}>
				<IconContext.Provider value={{className: "btn-icon actions-more"}}>
					<IoMdMore />
				</IconContext.Provider>
			</div>
			<ModifyOptionsRow onEdit={onEdit} onDelete={onDelete} showDropDown={showDropdown} />
		</div>
	)
}

export default CommentRow
